import React from "react";
import { useNavigate } from "react-router-dom";
import ImageTag from "../ImageTag/Index";

const ExhibitionCards = ({ exhibitions = [] }) => {
  const navigate = useNavigate();


  const handleCardClick = (exhibitionSlug) => {
    if (exhibitionSlug) {
      navigate(`/media/exhibitions/${exhibitionSlug}`);
    }
  };
  if (!exhibitions || exhibitions.length === 0) {
    return (
      <div className="exhibition-cards-container">
        <div className="text-center py-5">
          <h3>No exhibitions available at the moment</h3>
          <p>Please check back later for upcoming exhibitions.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="exhibition-cards-container">
      <div className="row">
        {exhibitions.map((exhibition) => (
          <div key={exhibition.id} className="col-lg-6 col-md-6 col-sm-12 mb-4">
            <div
              className="exhibition-card"
              onClick={() => handleCardClick(exhibition.slug)}
              style={{ cursor: "pointer" }}
            >
              {/* Card Image */}
              <div className="card-image-wrapper">
                <ImageTag
                  ImagePath={
                    exhibition.featured_image 
                  }
                  ImageAlt={exhibition.exhibition_name || "Exhibition"}
                  className="exhibition-featured-image "
                />
              </div>
              <div className="card-content">
                <h3 className="exhibition-title">
                  {exhibition.exhibition_name || "IEC Exhibition"}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExhibitionCards;
